<div class="data-lens-details">
  @if (isLoading() === false) {
    @if (model(); as item) {
      <div class="details-container">
        <!-- Header Section -->
        <div class="modern-header">
          <div class="header-title-row">
            @if (model()?.resourceTypeIcon) {
              <img [src]="model()?.resourceTypeIcon" alt="File Type" class="file-type-icon" />
            }
            <h1 class="file-name">{{ item.resourceName }}</h1>
          </div>

          <!-- Metadata Row - Two Column Layout -->
          <div class="metadata-row">
            <div class="metadata-column metadata-left">
              <div class="metadata-item inline">
                <span class="metadata-label">Item type</span>
                <span class="metadata-value">{{ getFileType() }}</span>
              </div>
              @if (!isWebsite()) {
                <div class="metadata-item inline">
                  <span class="metadata-label">File format</span>
                  <span class="metadata-value">{{ getFileFormat() }}</span>
                </div>
              }
              <div class="metadata-item inline">
                <span class="metadata-label">URL</span>
                <div class="url-value">
                  <img src="assets/images/data-lens/link.svg" alt="URL" class="url-icon" />
                  @if (hasUrl(item)) {
                    <a
                      class="url-text url-link"
                      [href]="getUrl(item)"
                      [title]="getUrl(item)"
                      target="_blank"
                      rel="noopener noreferrer"
                      >{{ getTruncatedUrl(item) }}</a
                    >
                  } @else {
                    <span class="url-text no-url">N/A</span>
                  }
                </div>
              </div>
            </div>
            <div class="metadata-column metadata-right">
              <div class="metadata-item inline">
                <span class="metadata-label">Findings</span>
                @if (hasFindings(item)) {
                  <div class="clickable-value" (click)="viewRisk()">
                    <app-severities-cell
                      [severities]="item.findingsBySeverity"
                      [showSeverityCount]="true"
                      [interactable]="true"
                    />
                  </div>
                } @else {
                  <span class="metadata-value">-</span>
                }
              </div>
              <div class="metadata-item inline">
                <span class="metadata-label">Access count</span>
                <span class="metadata-value clickable-value" (click)="viewDataItemActivity()">
                  {{ item.accessCount }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- Content Sections -->
        <div class="content-sections">
          <!-- Data Item Content Section - Only shown when fetchContentInfo is available -->
          @if (canFetchContent()) {
            <div class="content-card data-content-card">
              <h3 class="card-title">Data item content</h3>
              <div class="content-row">
                <div class="content-warning">
                  <img src="assets/images/common/info.svg" alt="Info" class="warning-icon" />
                  <span class="warning-text"
                    >Data may contain sensitive user content, which is fetched in real-time and not stored.</span
                  >
                </div>
                <button class="fetch-button" (click)="fetchContent()" [disabled]="contentLoading()">
                  @if (contentLoading()) {
                    <mat-spinner diameter="16"></mat-spinner>
                  } @else {
                    Fetch content
                  }
                </button>
              </div>
              @if (contentFetched()) {
                <div class="fetched-content">
                  @if (contentLoading()) {
                    <div class="content-loading">
                      <mat-spinner diameter="24"></mat-spinner>
                    </div>
                  } @else {
                    <div class="snippet-content">{{ getSnippetContent() }}</div>
                  }
                </div>
              }
            </div>
          }

          <!-- Sensitivity Section -->
          <div class="section-wrapper">
            <h3 class="section-title">Sensitivity</h3>
            <div class="content-card sensitivity-card">
              @if (hasSensitivityIndicators()) {
                <div class="sensitivity-list">
                  @if (getSensitivityLabel()) {
                    <div class="sensitivity-pill">
                      <img
                        src="assets/images/data-lens/sensitivity-label-icon.svg"
                        alt="Sensitivity label"
                        class="sensitivity-icon"
                      />
                      <span class="sensitivity-label">Sensitivity label</span>
                      <span class="sensitivity-divider"></span>
                      <span class="sensitivity-value">{{ getSensitivityLabel() }}</span>
                    </div>
                  }
                  @if (getSensitiveLocation()) {
                    <div class="sensitivity-pill">
                      <img
                        src="assets/images/data-lens/sensitive-location-icon.svg"
                        alt="Sensitive location"
                        class="sensitivity-icon"
                      />
                      <span class="sensitivity-label">Sensitive location</span>
                      <span class="sensitivity-divider"></span>
                      <span class="sensitivity-value">{{ getSensitiveLocation() }}</span>
                    </div>
                  }
                  @if (getSensitiveInfo()) {
                    <div class="sensitivity-pill">
                      <img
                        src="assets/images/data-lens/sensitive-info-icon.svg"
                        alt="Sensitive info"
                        class="sensitivity-icon"
                      />
                      <span class="sensitivity-label">Sensitive info</span>
                      <span class="sensitivity-divider"></span>
                      <span class="sensitivity-value">{{ getSensitiveInfo() }}</span>
                    </div>
                  }
                </div>
              } @else {
                <span style="color: #696879; font-size: 13px">No sensitivity indicators found.</span>
              }
            </div>
          </div>

          <!-- Access Over Time Section -->
          <div class="section-wrapper">
            <h3 class="section-title">Access over time</h3>
            <div class="content-card">
              <div class="access-time-header">
                <span class="access-period">Total access by platform</span>
                @if (getDateRange()) {
                  <div class="date-range-picker">
                    <button
                      class="date-nav-button"
                      (click)="navigateDateRange(-1)"
                      [disabled]="!canNavigatePrevious()"
                      aria-label="Previous period"
                    >
                      <svg viewBox="0 0 16 16" fill="currentColor" width="12" height="12">
                        <path d="M10 12L6 8l4-4" stroke="currentColor" stroke-width="2" fill="none" />
                      </svg>
                    </button>
                    <span class="date-range">{{ getDateRange() }}</span>
                    <button
                      class="date-nav-button"
                      (click)="navigateDateRange(1)"
                      [disabled]="!canNavigateNext()"
                      aria-label="Next period"
                    >
                      <svg viewBox="0 0 16 16" fill="currentColor" width="12" height="12">
                        <path d="M6 4l4 4-4 4" stroke="currentColor" stroke-width="2" fill="none" />
                      </svg>
                    </button>
                  </div>
                }
              </div>
              @if (accessAnalytics()) {
                <div class="chart-container-wrapper">
                  <div class="chart-container" [class.loading]="accessAnalyticsLoading()">
                    <app-stacked-bar-chart
                      [chartData]="activityHistogramData()"
                      [showLegend]="true"
                      [hideYAxis]="true"
                      [roundedBars]="true"
                    ></app-stacked-bar-chart>
                  </div>
                  @if (accessAnalyticsLoading()) {
                    <div class="chart-loading-overlay">
                      <mat-spinner diameter="40"></mat-spinner>
                    </div>
                  }
                </div>
              } @else if (accessAnalyticsLoading()) {
                <div class="chart-loading">
                  <mat-spinner diameter="40"></mat-spinner>
                </div>
              } @else {
                <div class="no-data-placeholder">No access data available</div>
              }
            </div>
          </div>

          <!-- File Access Charts Section -->
          <div class="charts-grid">
            <div class="content-card">
              <h3 class="card-title">Top Agents by Data Access</h3>
              <div class="chart-wrapper horizontal">
                @if (topAnalyticsLoading()) {
                  <div class="chart-loading">
                    <mat-spinner diameter="40"></mat-spinner>
                  </div>
                } @else if (topAnalytics()) {
                  <div class="legend-list vertical">
                    @for (agent of accessByAgentData(); track agent.label) {
                      <div class="legend-item clickable-value" (click)="viewAgentActivity(agent.id)">
                        <span class="legend-dot" [ngStyle]="{ 'background-color': agent.color }"></span>
                        <span class="legend-text">{{ agent.label }}</span>
                      </div>
                    }
                  </div>
                  <div class="pie-with-center">
                    <div class="pie-chart-container">
                      <app-pie-chart
                        [chartData]="accessByAgentData()"
                        [showLegend]="false"
                        [elevatedTooltip]="true"
                      ></app-pie-chart>
                    </div>
                    <div class="access-summary">
                      <div class="total-accesses">{{ getTotalAccesses() }}</div>
                      <div class="accesses-label">Accesses</div>
                    </div>
                  </div>
                } @else {
                  <div class="no-data-placeholder">No agent access data available</div>
                }
              </div>
            </div>

            <div class="content-card">
              <h3 class="card-title">Top Users by Data Access</h3>
              <div class="user-list-wrapper">
                @if (topAnalyticsLoading()) {
                  <div class="chart-loading">
                    <mat-spinner diameter="40"></mat-spinner>
                  </div>
                } @else if (topAnalytics()) {
                  @if (accessByUserData(); as users) {
                    @if (users.length > 0) {
                      @for (user of users; track user.user) {
                        <div class="user-row clickable-value" (click)="viewUserActivity(user.userId)">
                          <div class="user-info">
                            <span class="user-email">{{ user.user }}</span>
                            <span class="user-count">{{ user.count }}</span>
                          </div>
                          <div class="user-progress-bar">
                            <div class="user-progress-fill" [style.width.%]="user.percentage"></div>
                          </div>
                        </div>
                      } @empty {
                        <div class="no-data-placeholder">No user access data available</div>
                      }
                    } @else {
                      <div class="no-data-placeholder">No user access data available</div>
                    }
                  }
                } @else {
                  <div class="no-data-placeholder">No user access data available</div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    } @else {
      <div class="no-data-message">
        <p>No data layer item details available</p>
      </div>
    }
  } @else {
    <div class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  }
</div>
